import type { Schedule, Weekday } from '../types';
import { WEEKDAYS } from '../types';

// 開始時刻が終了時刻以降になっている曜日を返す。バックエンド UpdateScheduleSchema の
// from < to 制約に対応する事前検証。from/to は "HH:MM"（5文字固定）のため、
// 文字列の辞書順比較が時刻の前後比較と一致する。休業日（null）と片側未入力は対象外。
export const findInvertedScheduleEntries = (schedule: Schedule): Weekday[] =>
  WEEKDAYS.filter(day => {
    const { from, to } = schedule[day];
    return from !== null && to !== null && from >= to;
  });
